const React = require('react');
const {
  LINK_DASHBOARD,
} = require('../../../../constants/links');
const withState = require('../../../../utils/withState');
const {
  replaceLocation,
} = require('../../../../router');
const {
  account$,
  loadingAccount$,
} = require('../../../../emitters/account');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading/B');
const AppIcon = require('../../../icons/Lunu');
const {API_URL_HOST} = require("../../../../config/api");
const Ripple = require("../../../dumb/Ripple");
const changeHostnamePopup = require("../../../smart/Popup/changeHostnamePopup");

const {
  signOut,
} = account$;


module.exports = withState(() => {
  return (state, props) => {
    const {
      account,
    } = state;

    account && account.verified && replaceLocation({
      path: LINK_DASHBOARD,
    });

    const cachedAccount = props.cachedAccount || account;
    const showAPISelect = ['dev'].some((key) => location.hostname.includes(key));

    return (
      <div className="abs s ovx ovyS bgF ff$3 c0">
        <WrapperWithLoading
          loading={state.loading || props.loading}
        >
          <div className="h100vh hAuto@m">
            <div className="hmin80 hmin120@m h17%@d layoutRow fhaC fvaC">
              <div className="w1200 wmax mhA ph15">
                <div className="hmin17%@d layoutRow fhaB fvaC">
                  <a
                    className="layoutRow fhaS fvaC tdN olN dn o70:h"
                    onClick={signOut}
                  >
                    <AppIcon className="w128 mr20 rlv c0" />
                    <div
                      className="c5B47FF fw3 f16 lh30 lts0em"
                    >Console</div>
                  </a>
                  {
                    cachedAccount ? (
                      <div className="layoutRow fhaS fvaC">
                        <div
                          className="pr15 f12 fw3 lh lts0em c0"
                        >{cachedAccount.username || ''}</div>
                        <a
                          className="f16 fw3 lh lts0em c5B47FF ttU dn o70:h"
                          onClick={signOut}
                        >log out</a>
                      </div>
                    ) : null
                  }
                </div>
              </div>
            </div>
            <div className="hmin66%@d layoutRow fhaC fvaC">
              {props.content}
            </div>
            <div className="hmin80 h17%@d dN@m"/>
          </div>
          {showAPISelect && (
            <div className="w1200 wmax hmin80 hminAuto@m ph15 abs sl50% x-50%Y0 sb20 (rlv|pv20)@m">
              <Ripple className='wFitContent' onClick={changeHostnamePopup}>
                Current API: {API_URL_HOST}
              </Ripple>
            </div>
          )}
        </WrapperWithLoading>
      </div>
    );
  };
}, {
  loading: loadingAccount$,
  account: account$,
});
